// The RAG pipeline labels every retrieved source it hands the model, as
// `[DOCUMENT: Iowa_Lihtc_Compliance_Manual_2022_State_Manual.pdf]` and
// `[IMAGE: ...]` (see rag_service.py). Those labels are addressed to the model,
// not to a reader, and the model tends to echo them into its answer.
//
// The rendered chat has always stripped them, but everything else that consumed a
// message did not: copying pasted them into the user's document, Save to Notes
// stored them, and text-to-speech read them out loud. One exported stripper, used
// by every consumer, is what keeps those from drifting apart again.
//
// Whitespace immediately before a marker goes with it, so removing one mid-sentence
// does not leave a double space. Nothing else about the text is touched: collapsing
// runs of spaces generally would break markdown that depends on them, such as
// nested list indentation and code blocks.
const CONTEXT_MARKERS = /[ \t]*\[(?:DOCUMENT|IMAGE):[^\]]*\]/g;

export function stripContextMarkers(text) {
  if (typeof text !== 'string') return '';
  return text
    .replace(CONTEXT_MARKERS, '')
    .replace(/\n{3,}/g, '\n\n');
}
